import useExplorerData, { Loading } from 'hooks/useExplorerData';
import useQueryParams from 'hooks/useQueryParams';

// Thin wrapper over useExplorerData for the AdvancedSearch filter-lookup
// pattern: fetch a hydration endpoint once the filter has a value, expose
// `{ data, loading }` as a boolean rather than the Loading enum.
//
// `enabled` defaults to true. When it flips false the in-flight request is
// aborted (by useExplorerData) and `data` is hidden from the consumer.
// `reloadOn` defaults to ['filters'] so chip labels refresh when the URL
// filters change (e.g. back/forward to a saved search with different IDs).
const useFilterLookup = (path, { enabled = true, reloadOn = ['filters'] } = {}) => {
  const params = useQueryParams();
  const { data, loading } = useExplorerData(path, params, { enabled, reloadOn });

  return {
    data: enabled ? data : null,
    loading: enabled && (loading === Loading.NOT_STARTED || loading === Loading.IN_PROGRESS)
  };
};

export default useFilterLookup;
